var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.get_class,domProps:{"innerHTML":_vm._s(_vm.display_value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }